import services from 'api/services';
import { logError } from 'util/errors';

import {
  LOAD_TESTS_REQUEST,
  LOAD_TESTS_SUCCESS,
  LOAD_TESTS_FAILURE,
  PUBLISH_AND_ARCHIVE_TEST_REQUEST,
  PUBLISH_AND_ARCHIVE_TEST_SUCCESS,
  PUBLISH_AND_ARCHIVE_TEST_FAILURE,
  COPY_TEST_REQUEST,
  COPY_TEST_SUCCESS,
  COPY_TEST_FAILURE,
  CREATE_TEST_REQUEST,
  CREATE_TEST_SUCCESS,
  CREATE_TEST_FAILURE,
} from './constants';

const { TestService } = services;

export const getTests = () => async (dispatch) => {
  try {
    dispatch({ type: LOAD_TESTS_REQUEST });
    const tests = await TestService.getTests();
    dispatch({ type: LOAD_TESTS_SUCCESS, data: tests });
  } catch (ex) {
    logError(ex);
    dispatch({ type: LOAD_TESTS_FAILURE, error: ex.message });
  }
};

export const publishAndArchiveTest = (id, body) => async (dispatch) => {
  try {
    dispatch({ type: PUBLISH_AND_ARCHIVE_TEST_REQUEST });
    const test = await TestService.publishAndArchiveTest(id, body);
    dispatch({ type: PUBLISH_AND_ARCHIVE_TEST_SUCCESS, data: test });
  } catch (ex) {
    logError(ex);
    dispatch({ type: PUBLISH_AND_ARCHIVE_TEST_FAILURE, error: ex.message });
  }
};

export const copyTest = (id, isMultichoice) => async (dispatch) => {
  try {
    dispatch({ type: COPY_TEST_REQUEST });
    let test;
    if (isMultichoice) test = await TestService.copyMultichoice(id);
    else ({ test } = await TestService.copyFreecode(id));
    dispatch({ type: COPY_TEST_SUCCESS, data: test });
  } catch (ex) {
    logError(ex);
    dispatch({ type: COPY_TEST_FAILURE, error: ex.message });
  }
};

export const createTest = (body, isMultichoice) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_TEST_REQUEST });
    let test;
    if (isMultichoice) test = await TestService.createMultichoiceTest(body);
    else test = await TestService.createFreecodeTest(body);
    dispatch({ type: CREATE_TEST_SUCCESS, data: test });
  } catch (ex) {
    logError(ex);
    dispatch({ type: CREATE_TEST_FAILURE, error: ex.message });
  }
};
